<div class="session-expired-container">
  <p style="margin: 0 0 30px 0">{{ "login.intro" | translate }}</p>
  @if (wrongInput) {
    <small class="p-error">{{ "login.invalid_credentials" | translate }}</small>
  }
  <div class="buttons">
    <button class="costa-button" type="submit" (click)="signIn()">
      {{ "login.title" | translate }}
    </button>
  </div>
</div>
